import { useBooleanFlagValue, useSuspenseFlag } from '@openfeature/react-sdk';

import { DDFeatureFlag } from './data-dog-feature-flag.model';

const DEFAULT_FLAG_VALUES: Record<DDFeatureFlag, boolean> = {
  FCT_ADDENDUM: false,
  FCT_AI_ADDENDUM: false,
  FCT_AI_FINAL_IMPRESSIONS: false,
  FCT_CARE_PLAN_NOTES: false,
  FCT_CHARACTER_LIMITS: false,
  FCT_COMPARISON_V2: false,
  FCT_CONDITION_TEMPLATE_DISPLAY_NAME: false,
  FCT_FHIR_QUESTIONNAIRE_RESPONSE: false,
  FCT_HIDE_HEART_HEALTH_QUALITY_REVIEW: false,
  FCT_INCOMPLETE_SCAN_ONLY: false,
  FCT_RQ_FINDINGS: false,
  FCT_RQ_REPORT_ORGAN: false,
  FCT_USER_PREFERENCES: false,
};

if (import.meta.env.MODE === 'msw') {
  for (const key of Object.keys(DEFAULT_FLAG_VALUES)) {
    DEFAULT_FLAG_VALUES[key as DDFeatureFlag] = true;
  }
}

export function useIsDDFeatureFlagEnabled(flag: DDFeatureFlag) {
  return useBooleanFlagValue(flag, DEFAULT_FLAG_VALUES[flag]);
}

export function useDDSuspenseFeatureFlag(flag: DDFeatureFlag) {
  return useSuspenseFlag(flag, DEFAULT_FLAG_VALUES[flag]).value;
}
